import { Flex } from 'vvs-uikit'
import PixelatedImage from 'views/VvsGotchi/components/PixelatedImage'

import { MOLE_DASH_MAX_EXP } from '../config'

const ExpStars: React.FC<{ exp: number }> = ({ exp }) => {
  return (
    <Flex gap="3px">
      {Array(MOLE_DASH_MAX_EXP)
        .fill(undefined)
        .map((_, i) => i + 1)
        .map((currentExp) => (
          <PixelatedImage
            key={currentExp}
            src={currentExp <= exp ? '/images/vvsGotchi/star.png' : '/images/vvsGotchi/star_gray.png'}
          />
        ))}
    </Flex>
  )
}

export default ExpStars
